import {ChangeDetectorRef, Component, ViewChild} from "@angular/core";
import {EntityModelStatus, provideEntityModel} from "@fedeltapointofsale/data-client";
import {MeasureEntityModel} from "../measure-entity.model";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {EditPageComponent} from "../../../framework/entity/edit/edit-page/edit-page.component";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-measure-edit-page",
    templateUrl: "./measure-edit-page.component.html",
    providers: [(provideEntityModel(MeasureEntityModel))]
})
export class MeasureEditPageComponent extends AbstractEditPage {

    public static readonly RESTRICTED_BASE_MEASURE_ID = "RESTRICTED_BASE_MEASURE_ID";

    restrictedBaseMeasureId: boolean;

    constructor(public model: MeasureEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
        this.model.$data.subscribe(() => {
            this.model.data.hasCntQty = this.model.data.ctnQty != null;
            if (this.model.status === EntityModelStatus.INSERT && this.editParams && this.editParams[MeasureEditPageComponent.RESTRICTED_BASE_MEASURE_ID]) {
                this.model.data.baseConversion.convertTo.measureId = this.editParams[MeasureEditPageComponent.RESTRICTED_BASE_MEASURE_ID];
                this.restrictedBaseMeasureId = true;
            }
        });
    }

    disableCntQtyOnChange(): void {
        this.editPageComponent.formGroup.get("ctnQty").reset(null);
    }

    get hasCntQty(): boolean {
        return this.model.data.hasCntQty;
    }

    set hasCntQty(value: boolean) {
        if (value != undefined) {
            this.model.data.hasCntQty = value;
        }
    }

    baseChanged(): void {
        if (this.model.data.base) {
            this.editPageComponent.formGroup.get("baseConversion").get("convertTo").get("measureId").reset(null);
            this.editPageComponent.formGroup.get("baseConversion").get("factor").reset(null);
        }
    }
}
